import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services/api';
import { Transcription } from 'src/models';
import { useGetTranscriptionList } from './useGetTranscriptionList';

type UseUpdateTranscriptionPayload = {
  transcriptionId: string;
  payload: Pick<Transcription, 'transcription_json'>;
};

export const useUpdateTranscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateTranscription'],
    mutationFn: ({
      transcriptionId,
      payload,
    }: UseUpdateTranscriptionPayload) => {
      queryClient.setQueriesData<
        ReturnType<typeof useGetTranscriptionList>['data']
      >({ queryKey: ['transcriptionList'] }, (oldData) => {
        if (!oldData) return oldData;

        const newTranscriptions = oldData.transcriptions.map(
          (transcription) => {
            if (transcription.transcription_id !== transcriptionId)
              return transcription;
            return {
              ...transcription,
              ...payload,
            };
          }
        );

        return {
          ...oldData,
          transcriptions: newTranscriptions,
        };
      });
      return ambientApi
        .put(`/transcriptions/${transcriptionId}`, payload)
        .then((res) => res.data);
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ['transcriptionList'] });
    },
  });
};
